var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PaymentMethodItem from '../PaymentMethodItem';
import { matchProviderType } from '../../Payment';

var getPaymentDetailByMethod = function getPaymentDetailByMethod(payments, method) {
  return payments.find(function (p) {
    return matchProviderType(p, method);
  }) || {};
};

var PaymentMethodSelector = function (_Component) {
  _inherits(PaymentMethodSelector, _Component);

  function PaymentMethodSelector() {
    _classCallCheck(this, PaymentMethodSelector);

    return _possibleConstructorReturn(this, (PaymentMethodSelector.__proto__ || Object.getPrototypeOf(PaymentMethodSelector)).apply(this, arguments));
  }

  _createClass(PaymentMethodSelector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          methods = _props.methods,
          currency = _props.currency,
          payments = _props.payments,
          selectedMethod = _props.selectedMethod,
          selectedAccount = _props.selectedAccount,
          onSelectAccount = _props.onSelectAccount,
          onSelectMethod = _props.onSelectMethod,
          onDeleteAccount = _props.onDeleteAccount;


      return React.createElement(
        'div',
        { className: 'payment-method-selector' },
        methods.map(function (method) {
          return React.createElement(PaymentMethodItem, {
            key: method.txType + method.service,
            method: method,
            currency: currency,
            detail: getPaymentDetailByMethod(payments, method),
            selectedMethod: selectedMethod,
            selectedAccount: selectedAccount,
            onSelectMethod: onSelectMethod,
            onSelectAccount: onSelectAccount,
            onDeleteAccount: onDeleteAccount
          });
        })
      );
    }
  }]);

  return PaymentMethodSelector;
}(Component);

export default PaymentMethodSelector;